export default "__VITE_ASSET__CltAHrtS__"